import { LimitTypeListTable } from '../components/LimitTypeListTable';

export function LimitTypeListPage() {
  return <LimitTypeListTable />;
}
